import { render, staticRenderFns } from "./franchiseesuserlist.vue?vue&type=template&id=cb19041c&scoped=true"
import script from "./franchiseesuserlist.vue?vue&type=script&lang=js"
export * from "./franchiseesuserlist.vue?vue&type=script&lang=js"
import style0 from "./franchiseesuserlist.vue?vue&type=style&index=0&id=cb19041c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb19041c",
  null
  
)

export default component.exports